import React from 'react';
import ReactDOM from 'react-dom/client';

import { init } from '@plausible-analytics/tracker';

import App from './App.tsx';
import { getGlobalAnalyticsProps } from './lib/analytics.ts';
import { initSentry } from './lib/sentry.ts';

import './index.css';

if (import.meta.env.VITE_SENTRY_ENVIRONMENT !== 'dev') {
  initSentry({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    tracesSampleRate: import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE
      ? Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE)
      : undefined,
  });
  init({
    domain: import.meta.env.VITE_PLAUSIBLE_DOMAIN,
    customProperties: () => getGlobalAnalyticsProps(),
  });
}
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
